<template>
  <div class="portrait-of-enterprises-in-the-park">
    <el-button type="primary" size="small" @click="getPdf()" style="width: 80px;position: absolute;left: 10px;top: 10px;">导出PDF</el-button>
    <div class="portrait-of-enterprises-in-the-park-info-pdf" id="pdfDom">
      <div class="portrait-of-enterprises-in-the-park-top">
        <div class="portrait-of-enterprises-in-the-park-top-enterprise-name">{{enterpriseName}}</div>
      </div>

      <div class="portrait-of-enterprises-in-the-park-main">
        <div>
          <!-- 企业基础信息 -->
          <div class="portrait-of-enterprises-item">
            <div class="portrait-of-enterprises-item-title">
              <i class="portrait-of-enterprises-item-title-icon el-icon-damai-basic"></i>
              <span class="portrait-of-enterprises-item-title-info">企业基础信息</span>
            </div>
            <div class="portrait-of-enterprises-item-table-box">
              <div class="portrait-of-enterprises-item-table-line">
                <div class="portrait-of-enterprises-item-table-line-title">企业标签</div>
                <div class="portrait-of-enterprises-item-table-line-info">{{basicInfo.labelNames || '无'}}</div>
              </div>
              <div class="portrait-of-enterprises-item-table-line">
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">行业类型</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{basicInfo.companyOrgType || '无'}}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">成立时间</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{basicInfo.estiblishTime || '无'}}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">注册资本</div>
                  <div class="portrait-of-enterprises-item-table-line-info">无</div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item-table-line">
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">入住时间</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{ basicInfo.contractStartTime || '无' }}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">租赁地址</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{basicInfo.roomNumer || '无'}}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">租赁面积</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{basicInfo.roomArea || '0'}}m²</div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item-table-line">
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">人员数量</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{basicInfo.personCount || '无'}}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">合同到期日</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{basicInfo.contractEndTime || '无'}}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">企业质量</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{basicInfo.radarScore || '无'}}</div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item-table-line" style="flex: 1;">
                <div class="portrait-of-enterprises-item-table-line-title">发展分析</div>
                <div class="portrait-of-enterprises-item-table-line-info">{{basicInfo.developeAnalysis || '无'}}</div>
              </div>
            </div>
          </div>
          <!-- 企业工商信息 -->
          <div class="portrait-of-enterprises-item">
            <div class="portrait-of-enterprises-item-title">
              <i class="portrait-of-enterprises-item-title-icon el-icon-damai-qi"></i>
              <span class="portrait-of-enterprises-item-title-info">企业工商信息</span>
            </div>
            <div class="portrait-of-enterprises-item-table-box">
              <div class="portrait-of-enterprises-item-table-line">
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">法定代表人</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{businessInfo.legalPersonName || '无'}}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">登记状态</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{businessInfo.regStatus || '无'}}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">企业类型</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{businessInfo.companyOrgType || '无'}}</div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item-table-line">
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">组织机构代码</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{businessInfo.orgNumber || '无'}}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">统一社会信用代码</div>
                  <div class="portrait-of-enterprises-item-table-line-info">{{businessInfo.creditCode || '无'}}</div>
                </div>
                <div class="portrait-of-enterprises-item-table-line-item">
                  <div class="portrait-of-enterprises-item-table-line-title">营业期限</div>
                  <div class="portrait-of-enterprises-item-table-line-info">无</div>
                </div>
              </div>
              <div class="portrait-of-enterprises-item-table-line">
                <div class="portrait-of-enterprises-item-table-line-title">登记机关</div>
                <div class="portrait-of-enterprises-item-table-line-info">{{businessInfo.regInstitute || '无'}}</div>
              </div>
              <div class="portrait-of-enterprises-item-table-line">
                <div class="portrait-of-enterprises-item-table-line-title">注册地址</div>
                <div class="portrait-of-enterprises-item-table-line-info">{{businessInfo.regLocation || '无'}}</div>
              </div>
              <div class="portrait-of-enterprises-item-table-line" style="flex: 1;">
                <div class="portrait-of-enterprises-item-table-line-title">经营范围</div>
                <div class="portrait-of-enterprises-item-table-line-info">{{businessInfo.businessScope || '无'}}</div>
              </div>
            </div>
          </div>
          <!-- 企业质量 -->
          <div class="portrait-of-enterprises-item">
            <div class="portrait-of-enterprises-item-title">
              <i class="portrait-of-enterprises-item-title-icon el-icon-damai-company_quality"></i>
              <span class="portrait-of-enterprises-item-title-info">企业质量</span>
            </div>
            <radar style="flex: 1;" radarId="enterpriseQualityRadarId" :titleStyle="commonTitleStyle" :radarColor="enterpriseQualityRadarColor" :legendData="enterpriseQualityRadarLegendData" :radarAxisData="enterpriseQualityRadarAxisData" :series="enterpriseQualityRadarSeriesData" />
          </div>
        </div>

        <div style="margin-top: 40px;">
          <div class="portrait-of-enterprises-item" style="display: flex;justify-content: space-between;align-items: center;flex-direction: initial;">
            <!-- 学历分布 -->
            <div class="portrait-of-enterprises-item-child">
              <div class="portrait-of-enterprises-item-title">
                <i class="portrait-of-enterprises-item-title-icon el-icon-damai-xueli"></i>
                <span class="portrait-of-enterprises-item-title-info">学历分布</span>
              </div>
              <common-ring commonRingId="educationMultilineId" height="100%" style="flex: 1;" :colorList="educationMultilineColor" :ringLegend="educationMultilineLegendData" :ringData='educationMultilineSeriesData'/>
              <!--            <common-multiline  commonMultilineId="educationMultilineId" :legendData="educationMultilineLegendData" :multilineXAxis="educationMultilineXAxis" :series="educationMultilineSeriesData"/>-->
            </div>
            <!-- 知识产权 -->
            <div class="portrait-of-enterprises-item-child">
              <div class="portrait-of-enterprises-item-title">
                <i class="portrait-of-enterprises-item-title-icon el-icon-damai-zhishichanquan1"></i>
                <span class="portrait-of-enterprises-item-title-info">知识产权</span>
              </div>
              <common-ring commonRingId="intellectualPropertyMultilineId" height="100%" style="flex: 1;" :colorList="intellectualPropertyMultilineColor" :ringLegend="intellectualPropertyMultilineLegendData" :ringData='intellectualPropertyMultilineSeriesData'/>
              <!--            <common-multiline style="flex: 1;" commonMultilineId="intellectualPropertyMultilineId" :multilineColor="intellectualPropertyMultilineColor" :legendData="intellectualPropertyMultilineLegendData" :multilineXAxis="intellectualPropertyMultilineXAxis" :series="intellectualPropertyMultilineSeriesData"/>-->
            </div>
          </div>
          <!-- 企业产值 -->
          <div class="portrait-of-enterprises-item">
            <div class="portrait-of-enterprises-item-title">
              <i class="portrait-of-enterprises-item-title-icon el-icon-damai-duoweitongji"></i>
              <span class="portrait-of-enterprises-item-title-info">企业产值</span>
            </div>
            <common-line-and-bar style="flex: 1;" commonLineAndBarId="enterpriseOutputValueId" :commonLineAndBarColor="enterpriseOutputValueColor" :legendData="enterpriseOutputValueLegendData" :commonLineAndBarXAxis="enterpriseOutputValueXAxis" :commonLineAndBarYAxis="enterpriseOutputValueYAxis" :series="enterpriseOutputValueSeriesData" />
          </div>
        </div>

        <div style="margin-top: 40px;">
          <!-- 税收分析 -->
          <div class="portrait-of-enterprises-item">
            <div class="portrait-of-enterprises-item-title">
              <i class="portrait-of-enterprises-item-title-icon el-icon-damai-shuishuai"></i>
              <span class="portrait-of-enterprises-item-title-info">税收分析</span>
            </div>
            <common-line-and-bar style="flex: 1;" commonLineAndBarId="taxRevenueId" :commonLineAndBarColor="taxRevenueColor" :legendData="taxRevenueLegendData" :commonLineAndBarXAxis="taxRevenueXAxis" :commonLineAndBarYAxis="taxRevenueYAxis" :series="taxRevenueSeriesData" />
          </div>
          <!-- 人员活跃度 -->
          <div class="portrait-of-enterprises-item">
            <div class="portrait-of-enterprises-item-title">
              <i class="portrait-of-enterprises-item-title-icon el-icon-damai-huoyuedutongji"></i>
              <span class="portrait-of-enterprises-item-title-info">人员活跃度</span>
            </div>
            <common-line-and-bar style="flex: 1;" commonLineAndBarId="personnelActivity" :commonLineAndBarColor="personnelActivityColor" :legendData="personnelActivityLegendData" :commonLineAndBarXAxis="personnelActivityXAxis" :commonLineAndBarYAxis="personnelActivityYAxis" :series="personnelActivitySeriesData" />
          </div>
          <!-- 能耗趋势 -->
          <div class="portrait-of-enterprises-item">
            <div class="portrait-of-enterprises-item-title">
              <i class="portrait-of-enterprises-item-title-icon el-icon-damai-nenghaoqushi"></i>
              <span class="portrait-of-enterprises-item-title-info">能耗趋势</span>
            </div>
            <common-line-and-bar style="flex: 1;" commonLineAndBarId="energyConsumption" :commonLineAndBarColor="energyConsumptionColor" :legendData="energyConsumptionLegendData" :commonLineAndBarXAxis="energyConsumptionXAxis" :commonLineAndBarYAxis="energyConsumptionYAxis" :series="energyConsumptionSeriesData" />
          </div>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
  import Radar from '../../../components/Echarts/Radar/Radar'
  import CommonMultiline from '../../../components/Echarts/Multiline/CommonMultiline'
  import CommonLineAndBar from '../../../components/Echarts/Multiline/CommonLineAndBar'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import {api} from '../../api/PortraitOfEnterpriseInfo'
  import {errorHandler} from '../../../utils/errorHandler'
  import CommonRing from "../../../components/Echarts/Pie/Pie/commonRing";

  export default {
    components: {
      CommonRing,
      swiper,
      swiperSlide,
      CommonLineAndBar,
      CommonMultiline,
      Radar
    },
    name: 'portrait-of-enterprises-in-the-park',
    data () {
      return {
        enterpriseCode: '',
        enterpriseName: '',
        htmlTitle: '',
        currentDay: '',

        basicInfo: {
          labelNames: '',
          radarScore: '',
          companyOrgType: '',
          estiblishTime: '',
          personCount: '',
          roomNumer: '',
          roomArea: '',
          contractEndTime: '',
          developeAnalysis: '',
          name: '',
        },

        // 工商信息
        businessInfo: {
          legalPersonName: '',
          regStatus: '',
          companyOrgType: '',
          orgNumber: '',
          creditCode: '',

          regInstitute: '',
          regLocation: '',
          businessScope: '',
        },

        commonTitleStyle: {
          color: '#666666'
        },

        // 企业质量
        enterpriseQualityRadarColor: ['#92D050', '#FFC000', '#77C8FF'],
        enterpriseQualityRadarLegendData: {},
        enterpriseQualityRadarAxisData: [
          {
            name: {
              textStyle: {
                color: '#666666',
              },
            },
            indicator: [
              {text: '基本面', max: 15},
              {text: '信誉', max: 5},
              {text: '活力', max: 10},
              {text: '成长性', max: 10},
              {text: '荣誉资质', max: 10},
              {text: '知识产权', max: 10},
              {text: '亩均产值', max: 20},
              {text: '产值税收', max: 20},
            ],
            radius: 120,
            center: ['50%', '50%'],
          },
        ],
        enterpriseQualityRadarSeriesData: [],

        // 学历分布
        educationMultilineColor: ['#77FFDE', '#92D050', '#77C8FF', '#FFC000', '#FF6F4D'],
        educationMultilineLegendData: {
          left: 'center',
          bottom: -5,
        },
        // educationMultilineLegendData: {
        //   textStyle: {
        //     color: '#666666',
        //     fontSize: 12,
        //   },
        //   padding: 0,
        //   itemGap: 1,
        //   itemWidth: 8,
        //   itemHeight: 8,
        //   right: 0,
        //   data: ['博士', '硕士', '本科', '大专', '高中及以下']
        // },
        educationMultilineXAxis: [],
        educationMultilineSeriesData: [],

        // 知识产权
        intellectualPropertyMultilineColor: ['#77FFDE', '#92D050', '#77C8FF', '#FFC000', '#FF6F4D'],
        intellectualPropertyMultilineLegendData: {
          left: 'center',
          bottom: -5,
        },
        intellectualPropertyMultilineXAxis: [],
        intellectualPropertyMultilineSeriesData: [],

        // 企业产值
        enterpriseOutputValueColor: ['#77FFDE', '#92D050', '#77C8FF', '#FFC000', '#FF6F4D'],
        enterpriseOutputValueLegendData: {
          textStyle: {
            color: '#666666',
            fontSize: 12,
          },
          padding: 0,
          itemGap: 1,
          itemWidth: 8,
          itemHeight: 8,
          right: 0,
          data: ['产值', '亩均产值']
        },
        enterpriseOutputValueXAxis: [],
        enterpriseOutputValueYAxis: [
          {
            type: 'value',
            name: '',
            nameTextStyle: {
              color: '#666666',
            },
            axisLine:{
              lineStyle:{
                color:'#666666',
              }
            },
            splitLine: {
              show: false
            },
            minInterval: 1,
          }
        ],
        enterpriseOutputValueSeriesData: [],

        // 税收分析
        taxRevenueColor: ['#77FFDE', '#92D050', '#77C8FF', '#FFC000', '#FF6F4D'],
        taxRevenueLegendData: {
          textStyle: {
            color: '#666666',
            fontSize: 12,
          },
          padding: 0,
          itemGap: 1,
          itemWidth: 8,
          itemHeight: 8,
          right: 0,
          data: ['税收', '亩均税收']
        },
        taxRevenueXAxis: [],
        taxRevenueYAxis: [
          {
            type: 'value',
            name: '',
            nameTextStyle: {
              color: '#666666',
            },
            axisLine:{
              lineStyle:{
                color:'#666666',
              }
            },
            splitLine: {
              show: false
            },
            minInterval: 1,
          }
        ],
        taxRevenueSeriesData: [],

        // 人员活跃度
        personnelActivityColor: ['#77FFDE', '#92D050', '#77C8FF', '#FFC000', '#FF6F4D'],
        personnelActivityLegendData: {
          textStyle: {
            color: '#666666',
            fontSize: 12,
          },
          padding: 0,
          itemGap: 1,
          itemWidth: 8,
          itemHeight: 8,
          right: 0,
          data: ['活跃员工数', '15天以上人数']
        },
        personnelActivityXAxis: [],
        personnelActivityYAxis: [
          {
            type: 'value',
            name: '',
            nameTextStyle: {
              color: '#666666',
            },
            axisLine:{
              lineStyle:{
                color:'#666666',
              }
            },
            splitLine: {
              show: false
            },
            minInterval: 1,
          }
        ],
        personnelActivitySeriesData: [],

        // 能耗趋势
        energyConsumptionColor: ['#77FFDE', '#92D050', '#77C8FF', '#FFC000', '#FF6F4D'],
        energyConsumptionLegendData: {
          textStyle: {
            color: '#666666',
            fontSize: 12,
          },
          padding: 0,
          itemGap: 1,
          itemWidth: 8,
          itemHeight: 8,
          right: 0,
          data: ['本期能耗', '上年同期']
        },
        energyConsumptionXAxis: [],
        energyConsumptionYAxis: [
          {
            type: 'value',
            name: '',
            nameTextStyle: {
              color: '#666666',
            },
            axisLine:{
              lineStyle:{
                color:'#666666',
              }
            },
            splitLine: {
              show: false
            },
            minInterval: 1,
          }
        ],
        energyConsumptionSeriesData: [],
      }
    },
    created () {
      let nowDate = new Date
      let year = nowDate.getFullYear()
      let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
      let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
      this.currentDay = `${year}-${month}-${date}`
      this.enterpriseCode = this.$route.params.id
    },
    mounted () {
      this.getEnterpriseKeyData()
      this.getEnterpriseBusinessData()
      this.getEnterpriseRadarData()
      this.getEnterpriseEducationData()
      this.getEnterpriseIntellectualPropertyData()
      this.getEnterpriseOutputData()
      this.getEnterpriseTaxData()
      this.getEnterpriseActivityData()
      this.getEnterpriseEnergyUseData()
    },
    methods: {
      // 返回
      back () {
        this.$router.push({
          name: 'data-enterprise'
        })
      },
      // 企业基础信息
      getEnterpriseKeyData () {
        this.$axios.get(`${api.getEnterpriseKeyData}/${this.enterpriseCode}`, {})
          .then(res => {
            let data = res.data.data
            if (data.estiblishTime) {
              data.estiblishTime = this.timeFormat(data.estiblishTime)
            }
            this.basicInfo = data
            this.enterpriseName = data.name
            this.htmlTitle = `${data.name} ${this.currentDay}`
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 企业工商信息
      getEnterpriseBusinessData () {
        this.$axios.get(`${api.getEnterpriseBusinessData}/${this.enterpriseCode}`, {})
          .then(res => {
            let data = res.data.data
            this.businessInfo = data
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 企业质量
      getEnterpriseRadarData () {
        this.$axios.get(`${api.getEnterpriseRadarData}/${this.enterpriseCode}`, {})
          .then(res => {
            let data = res.data.data
            if (data) {
              let timeArr = []
              let radarData = []
              data.map(v => {
                timeArr.unshift(v.date)
                let obj = {
                  value: [+v.fundmentScore, +v.reputationScore, +v.activityScore, +v.growScore, +v.labelsScore, +v.intellectualPropertyScore, +v.outputPerScore, +v.outputScore],
                  name: v.date
                }
                radarData.unshift(obj)
              })
              this.enterpriseQualityRadarLegendData = {
                bottom: 0,
                textStyle: {
                  color:'#666666',
                },
                data: timeArr
              }
              this.enterpriseQualityRadarSeriesData = [
                {
                  type: 'radar',
                  data: radarData
                }
              ]
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 学历分布
      getEnterpriseEducationData () {
        this.$axios.get(`${api.getEnterpriseEducationData}/${this.enterpriseCode}`, {})
          .then(res => {
            let data = res.data.data,
              educationMultilineSeriesData = [
                {name: '博士', value: 0, code: 'doctorCount'},
                {name: '硕士', value: 0, code: 'masterCount'},
                {name: '本科', value: 0, code: 'regularCount'},
                {name: '大专', value: 0, code: 'juniorCount'},
                {name: '高中及以下', value: 0, code: 'seniorCountArr'},
              ]
            if (data) {
              let newData = data[0] || []
              educationMultilineSeriesData.map(v => {
                v.value = newData[v.code] || 0
              })
            }
            this.educationMultilineSeriesData = educationMultilineSeriesData
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 知识产权
      getEnterpriseIntellectualPropertyData () {
        this.$axios.get(`${api.getEnterpriseIntellectualPropertyData}/${this.enterpriseCode}`, {})
          .then(res => {
            let data = res.data.data,
              intellectualPropertyMultilineSeriesData = [
                {name: '发明专利', value: 0, code: 'inventCount'},
                {name: '实用新型', value: 0, code: 'utilityCount'},
                {name: '外观专利', value: 0, code: 'facadeCount'},
                {name: '软著', value: 0, code: 'copyRegCount'},
                {name: '其他', value: 0, code: 'otherCount'},
              ]
            if (data) {
              let newData = data[0] || []
              intellectualPropertyMultilineSeriesData.map(v => {
                v.value = newData[v.code] || 0
              })
            }
            this.intellectualPropertyMultilineSeriesData = intellectualPropertyMultilineSeriesData
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 产值分析
      getEnterpriseOutputData () {
        this.$axios.get(`${api.getEnterpriseOutputData}/${this.enterpriseCode}`, {})
          .then(res => {
            let data = res.data.data
            if (data) {
              let outputArr = []
              let outputPerArr = []
              let timeArr = []
              data.map(v => {
                timeArr.unshift(v.date)
                outputArr.unshift(+v.output || 0)
                outputPerArr.unshift(+v.outputPer || 0)
              })
              this.enterpriseOutputValueXAxis = [
                {
                  type: 'category',
                  nameTextStyle: {
                    color: '#666666',
                  },
                  axisLine:{
                    lineStyle:{
                      color:'#666666',
                    }
                  },
                  splitLine: {
                    show: false
                  },
                  data: timeArr
                }
              ]
              this.enterpriseOutputValueSeriesData = [
                {
                  name: '产值',
                  type: 'line',
                  stack: '总量',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: '#77FFDE'
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#77FFDE'
                    }, {
                      offset: 1,
                      color: '#fff'
                    }])
                  },
                  data: outputArr
                }, {
                  name: '亩均产值',
                  type: 'line',
                  data: outputPerArr
                }
              ]
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 税收分析
      getEnterpriseTaxData () {
        this.$axios.get(`${api.getEnterpriseTaxData}/${this.enterpriseCode}`, {})
          .then(res => {
            let data = res.data.data
            if (data) {
              let taxArr = []
              let taxPerArr = []
              let timeArr = []
              data.map(v => {
                timeArr.unshift(v.date)
                taxArr.unshift(+v.tax || 0)
                taxPerArr.unshift(+v.taxPer || 0)
              })
              this.taxRevenueXAxis = [
                {
                  type: 'category',
                  nameTextStyle: {
                    color: '#666666',
                  },
                  axisLine:{
                    lineStyle:{
                      color:'#666666',
                    }
                  },
                  splitLine: {
                    show: false
                  },
                  data: timeArr
                }
              ]
              this.taxRevenueSeriesData = [
                {
                  name: '税收',
                  type: 'line',
                  stack: '总量',
                  smooth: true,
                  symbol: 'circle',
                  symbolSize: 5,
                  sampling: 'average',
                  itemStyle: {
                    color: '#77FFDE'
                  },
                  areaStyle: {
                    color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: '#77FFDE'
                    }, {
                      offset: 1,
                      color: '#fff'
                    }])
                  },
                  data: taxArr
                }, {
                  name: '亩均税收',
                  type: 'line',
                  data: taxPerArr
                }
              ]
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 人员活跃度
      getEnterpriseActivityData () {
        this.$axios.get(`${api.getEnterpriseActivityData}/${this.enterpriseCode}`, {})
          .then(res => {
            let data = res.data.data
            let activeCountArr = []
            let thresholdCountArr = []
            let timeArr = []
            if (data) {
              data.map(v => {
                timeArr.unshift(v.date)
                activeCountArr.unshift(+v.activeCount || 0)
                thresholdCountArr.unshift(+v.thresholdCount || 0)
              })
              this.personnelActivityXAxis = [
                {
                  type: 'category',
                  nameTextStyle: {
                    color: '#666666',
                  },
                  axisLine:{
                    lineStyle:{
                      color:'#666666',
                    }
                  },
                  splitLine: {
                    show: false
                  },
                  data: timeArr
                }
              ]
              this.personnelActivitySeriesData = [
                {
                  name: '活跃员工数',
                  type: 'bar',
                  data: activeCountArr
                }, {
                  name: '15天以上人数',
                  type: 'line',
                  data: thresholdCountArr
                }
              ]
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      // 能耗趋势
      getEnterpriseEnergyUseData () {
        this.$axios.get(`${api.getEnterpriseEnergyUseData}/${this.enterpriseCode}`, {})
          .then(res => {
            let data = res.data.data
            let energyUseArr = []
            let lastEnergyUseArr = []
            let timeArr = []
            if (data) {
              data.map(v => {
                timeArr.unshift(v.date)
                energyUseArr.unshift(+v.energyUse || 0)
                lastEnergyUseArr.unshift(+v.lastEnergyUse || 0)
              })
              this.energyConsumptionXAxis = [
                {
                  type: 'category',
                  nameTextStyle: {
                    color: '#666666',
                  },
                  axisLine:{
                    lineStyle:{
                      color:'#666666',
                    }
                  },
                  splitLine: {
                    show: false
                  },
                  data: timeArr
                }
              ]
              this.energyConsumptionSeriesData =[
                {
                  name: '本期能耗',
                  type: 'bar',
                  data: energyUseArr
                }, {
                  name: '上年同期',
                  type: 'line',
                  data: lastEnergyUseArr
                }
              ]
            }
          })
          .catch(errorHandler('获取数据失败'))
      },

      // 格式化时间传入毫秒数
      timeFormat (timeNum) {
        let nowDate = new Date(timeNum)
        let year = nowDate.getFullYear()
        let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
        let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
        let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
        let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
        let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
        let dateTime = year + '-' + month + '-' + date
        return dateTime
      },
    }
  }
</script>

<style scoped lang="less">
  .portrait-of-enterprises-in-the-park {
    min-width: 1200px;
    width: 100%;
    flex: 1;
    /*color: #666666;*/
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    background: #ffffff;
    background-size: 100% 100%;
    position: relative;
    .portrait-of-enterprises-in-the-park-info-pdf {
      /*min-width: 1200px;*/
      min-height: 758px;
      width: 1280px;
      height: 100%;
      margin: 0 auto;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      flex-direction: column;
      background: #ffffff;
      background-size: 100% 100%;
      .portrait-of-enterprises-in-the-park-top {
        height: 40px;
        line-height: 40px;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        .portrait-of-enterprises-in-the-park-top-enterprise-name {
          font-size: 28px;
          font-weight: 600;
        }
      }
      .portrait-of-enterprises-in-the-park-main {
        /*height: 89%;*/
        flex: 1;
        overflow: auto;
        color: #333333;
        .portrait-of-enterprises-item {
          width: 1200px;
          height: 500px;
          margin: 90px auto;
          /*background: url("../../../assets/corporatePortrait/top_frame.png") no-repeat;*/
          background-size: 100% 100%;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          .portrait-of-enterprises-item-child {
            width: 48%;
            height: 100%;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
          }
          .portrait-of-enterprises-item-title {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .portrait-of-enterprises-item-title-icon {
              font-size: 28px;
            }
            .portrait-of-enterprises-item-title-info {
              font-size: 18px;
              margin-left: 5px;
            }
          }
          .portrait-of-enterprises-item-table-box {
            flex: 1;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            border: 1px solid #aaaaaa;
            border-bottom: 0;
            margin: 20px 10px 0 10px;
            .portrait-of-enterprises-item-table-line {
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              border-bottom: 1px solid #aaaaaa;
              .portrait-of-enterprises-item-table-line-item {
                flex: 1;
                border-right: 1px solid #aaaaaa;
                display: flex;
                justify-content: flex-start;
                align-items: flex-start;
              }
              .portrait-of-enterprises-item-table-line-item:last-child {
                border-right: 0;
              }
              .portrait-of-enterprises-item-table-line-title {
                width: 120px;
                line-height: 40px;
                border-right: 1px solid #aaaaaa;
                height: 100%;
              }
              .portrait-of-enterprises-item-table-line-info {
                flex: 1;
                line-height: 40px;
                height: 100%;
                text-align: left;
                padding: 0 10px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/PortraitOfEnterprisesInThePark/PortraitOfEnterprisesInThePark.vue